import { Redirect, Route } from 'react-router-dom'
import { getAllowedRoutes } from 'utils'

const getPrivateRoutes = (appRoutes, props) => {
  const allowedRoutes = getAllowedRoutes(appRoutes)

  const routes = allowedRoutes.map((route) => {
    const { path, component: Component, children, title, permission, ...rest } = route

    return (
      <Route {...rest} {...props} key={path} path={`${path}`}>
        <Component children={children} {...props} />
      </Route>
    )
  })

  routes.push(
    <Route {...props} key="root" path="/" exact>
      <Redirect to={allowedRoutes[0].path} />
    </Route>
  )

  return routes
}

export default getPrivateRoutes
